// import { Link } from "@mui/material";
import { Suspense, useMemo } from "react";
import {
  //  Navigate,
  Route,
  Routes,
} from "react-router-dom";
import Layout from "./components/layout/Layout";
import ScrollToTop from "./components/ScrollToTop";
// import { subscribe } from "./config/axios";
import {
  routes as appRoutes,
  fullPagesRoutes as appFullPagesRoutes,
  // protectedFullPagesRoutes as appProtectedFullPagesRoutes,
  // id,
} from "./config/routes";
// import useAuth from "./hooks/useAuth";

function App() {
  // const { token } = useAuth();

  const routes = useMemo(
    () =>
      appRoutes.map((route) => {
        return (
          <Route key={route.id} path={route.path} element={route.component} />
        );
      }),
    []
  );

  // const protectedFullPageRoutes = useMemo(
  //   () =>
  //     appProtectedFullPagesRoutes.map((route) => (
  //       <Route
  //         key={route.id}
  //         path={route.path}
  //         element={
  //           token || route?.id !== id.video
  //             ? route.component
  //             : // <Navigate to="/login" />
  //               window.location.replace(subscribe)
  //         }
  //       />
  //     )),
  //   [token]
  // );

  const fullPagesRoutes = useMemo(
    () =>
      appFullPagesRoutes.map((route) => (
        <Route key={route.id} path={route.path} element={route.component} />
      )),
    []
  );

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <ScrollToTop>
        <Routes>
          {fullPagesRoutes}
          {/* {protectedFullPageRoutes} */}
          <Route path="/catagory" element={<Layout />}>
            {routes}
          </Route>
        </Routes>
      </ScrollToTop>
    </Suspense>
  );
}

export default App;
